import React, { useEffect } from 'react';

import { uniqueIdTransfer } from '@/apiCalls/uniqueIDTransferHelper';
import { EDisplays, selectDisplay } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';

import { EEventType } from '../eventType';

export interface IDisplayComponentProps {
    baseId: string;
    children: React.ReactNode;
    className?: string;
    [key: string]: unknown;
}

export const testId = 'display-component';

export function DisplayComponent({
    baseId,
    children,
    className,
    ...rest
}: IDisplayComponentProps): JSX.Element {
    const numChildren = React.Children.count(children);
    const displayScreen = useAppSelector(selectDisplay);
    const changeScreenHeight =
        displayScreen === EDisplays.PREPPROVAL_ANIMATION ||
        displayScreen === EDisplays.OCR_ANIMATION;
    useEffect(() => {
        uniqueIdTransfer({
            eventType: EEventType.VISIBLE_ON_SCREEN,
            applicationData: {
                id: `${baseId}-screen`,
            },
        });
    }, []);
    return (
        <div
            id={`${baseId}-screen`}
            className={`_flex flex-col h-full ${
                changeScreenHeight ? 'min-h-[601px]' : 'max-h-full'
            } w-[394px] overflow-y-auto ${className}`}
            {...rest}
            data-testid={testId}
        >
            {React.Children.map(children, (child, index) => {
                if (index === numChildren - 1) {
                    return (
                        <div className='flex-1 mt-auto px-8 _flex items-end'>
                            {child}
                        </div>
                    );
                } else {
                    return <div className='px-8'>{child}</div>;
                }
            })}
        </div>
    );
}
